import vex from "./vex_dialog";
import { getUITranslation } from "../utils/get_ui_translation";

export let CANCEL = {
  text: getUITranslation("Annuler"),
  type: "button",
  className: "vex-dialog-button-secondary",
  click: function () {
    this.value = false;
    this.close();
  },
};

export let OK = {
  text: getUITranslation("Ok"),
  type: "submit",
  className: "vex-dialog-button-primary",
  click: function () {
    this.value = true;
  },
};

export let CONTINUE = {
  text: getUITranslation("Continuer"),
  type: "submit",
  className: "vex-dialog-button-primary",
  click: function () {
    this.value = true;
  },
};

export let SAVE = {
  text: getUITranslation("Enregistrer"),
  type: "submit",
  className: "vex-dialog-button-primary",
  click: function () {
    this.value = true;
  },
};

export let NO = { ...vex.dialog.buttons.NO, text: getUITranslation("Non") };
export let CONFIRM = { ...vex.dialog.buttons.YES, text: getUITranslation("Confirmer") };

export let YES = { ...vex.dialog.buttons.YES, text: getUITranslation("Oui") };

export function saveCancel(title, message) {
  return vexOpen({
    message: title,
    input: message,
    buttons: [CANCEL, SAVE],
  });
}

export function confirmCancel(title, message) {
  return vexOpen({
    message: title,
    input: message,
    buttons: [CANCEL, CONFIRM],
  });
}

export function okCancel(title, message) {
  return vexOpen({
    message: title,
    input: message,
    buttons: [CANCEL, OK],
  });
}

export function yesNo(title, message) {
  return vexOpen({
    message: title,
    input: message,
    buttons: [NO, YES],
  });
}

export function alertError(title, message) {
  return vexOpen({
    message: title,
    input: message,
    buttons: [OK],
  });
}

export function alertInfo(title, message) {
  return vexOpen({
    message: title,
    input: message,
    buttons: [OK],
  });
}

// TODO Stop using this function and switch to either alertInfo or alertError depending on the use case
export function alert(title, message, _className, callback) {
  return vexOpen({
    message: title,
    input: message,
    buttons: [OK],
    callback: callback,
  });
}

// Wrapper around `vex.dialog.open` to return a Promise
function vexOpen(opts) {
  return new Promise((resolve) => {
    vex.dialog.open({
      ...opts,
      callback(...args) {
        resolve(...args);
        if (opts.callback) opts.callback(...args);
      },
    });
  });
}

export function htmlNoYes(title, messageHtml, callback) {
  html(title, messageHtml, [CANCEL], callback);
}

/**
 * @param {string} title Title for the Dialog
 * @param {string} messageHtml Dialog content in HTML
 * @param {Array}  buttons The buttons to display
 * @param {(any) -> void} cb Function called when the Dialog is called
 * @param {object} opts Vex Options object to set hooks
 */
export function html(title, messageHtml, buttons, cb, opts) {
  window._closeHTMLDialog = function (v) {
    window._vexContent.value = v;
    window._vexContent.close();
  };

  const options = {
    message: title,
    input: messageHtml,
    buttons: buttons,
    callback: function (v) {
      window._closeHTMLDialog = null;
      if (v && cb) cb.call(this, v);
    },
    ...opts,
  };

  window._vexContent = vex.dialog.open(options);
  return window._vexContent;
}
